<template>
  <div class="havya-menu">
    <div class="havya-content">
      <div class="havya-left">
        <img src="../assets/logo.png" class="logo" />
        <p>HAVYA SYSTEMS LLP</p>
      </div>
      <div class="havya-menubox">
        <div class="item" @click="selectMenu(1)">
          <div :class="step == 1 ? 'line' : 'lineActive'"></div>
          <p>Travel</p>
        </div>
        <div class="item" @click="selectMenu(2)">
          <div :class="step == 2 ? 'line' : 'lineActive'"></div>
          <p>Booking</p>
        </div>
        <div class="item" @click="selectMenu(3)">
          <div :class="step == 3 ? 'line' : 'lineActive'"></div>
          <p>Recommend</p>
        </div>
        <div class="item" @click="selectMenu(4)">
          <div :class="step == 4 ? 'line' : 'lineActive'"></div>
          <p>Contact Us</p>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
export default {
  name: "Menu",
  props: {
    step: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      index: 0,
    };
  },
  methods: {
    selectMenu(value) {
      this.index = value;
      if (value == this.step) {
        return;
      }
      switch (value) {
        case 1:
          this.$router.push({ path: "/" });
          break;
        case 2:
          this.$router.push({ path: "aboutUs" });
          break;
        case 3:
          this.$router.push({ path: "services" });
          break;
        case 4:
          this.$router.push({ path: "projects" });
          break;
        default:
          this.$router.push({ path: "/" });
          break;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.havya-menu {
  .havya-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 360px;
    background: #00B3C0;

    .havya-left {
      display: flex;
      align-items: center;
      position: relative;

      .logo {
        margin-right: 16px;
        width: 48px;
        height: 48px;
      }

      p {
        font-size: 40px;
        font-family: AvenirNextCondensed, AvenirNextCondensed;
        font-weight: 400;
        color: #FFFFFF;
      }
    }
  }

  .havya-menubox {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-family: ArialMT;
    color: #FFFFFF;
    cursor: pointer;

    .item {
      margin-right: 64px;

      .line {
        width: 19px;
        height: 2px;
        background: #FFFFFF;
      }

      .lineActive {
        width: 19px;
        height: 2px;
        background: #00B3C0;
      }

      p {
        margin-top: 14px;
      }
    }

    .item:nth-child(4) {
      margin-right: 0;
    }
  }
}
</style>
